// Typed face of the names Caliber keeps (lib/reserved-paths.js): the first
// segments that are Caliber's own pages, public routes, server paths and
// files, never a username. One list for the server and the browser.

// @ts-ignore — shared pure CJS engine, wrapped as ESM by vite.config.ts's
// cjs-engines plugin (the lib/seniority.js pattern).
import engine from '../../../lib/reserved-paths.js';

const e = engine as {
  RESERVED: readonly string[]; isReserved: (s: string) => boolean; firstSegment: (p: string) => string;
  fromOldAddress: (p: string) => string | null;
  isAddressable: (u: string) => boolean;
};

export const RESERVED: readonly string[] = e.RESERVED;
/** Is this first segment Caliber's own (never a username)? */
export const isReserved = (segment: string): boolean => e.isReserved(segment);
/** '/dark/skills' → 'dark'; '/' → ''. */
export const firstSegment = (pathname: string): string => e.firstSegment(pathname);
/** An old /@<username>/… link's address now, flush; null when no username follows the @. */
export const fromOldAddress = (pathname: string): string | null => e.fromOldAddress(pathname);
/** May this ofSelf username stand as a Caliber address (a base, a public page)? Not Caliber's names, the product's or nobody's. */
export const isAddressable = (username: string): boolean => e.isAddressable(username);
